/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url("../shared.css");

.qds-footer-subscription {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--qds-navigation-section-gap-children-unrelated);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--qds-navigation-section-gap-children-related);
}

.button {
  flex-shrink: 0;
}

.description {
  margin: 0;
  font: var(--qds-text-subdued);
  color: var(--qds-theme-text-subdued);
}

::slotted(p) {
  margin: 0;
}

.form-groups {
  display: flex;
  flex-direction: column-reverse;
  gap: var(--qds-navigation-section-gap-children-unrelated);
}

.action-group {
  display: flex;
  flex-direction: column;
  gap: var(--qds-navigation-section-gap-children-unrelated);
}

.feedback {
  display: flex;
  align-items: center;
  height: 88px;

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    border-radius: var(--qds-focus-border-radius);
    outline-offset: calc(
      var(--qds-focus-border-width) + var(--qds-focus-border-offset)
    );
  }
}

.hidden {
  display: none;
}

@media (width <= 767px) {
  .input-group {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    gap: var(--qds-control-standard-gap-siblings-related);
  }

  .control-group {
    display: flex;
    flex-direction: column;
  }

  .button {
    padding-top: 0.25rem;
  }
}

@media (width > 767px) {
  .input-container {
    display: flex;
    height: 88px;
    align-items: center;
  }

  .input-group {
    display: flex;
    align-items: flex-end;
    width: 100%;
  }

  .input-group > :not(:first-child, :last-child) {
    --qds-control-border-radius-top-left: 0px;
    --qds-control-border-radius-top-right: 0px;
    --qds-control-border-radius-bottom-right: 0px;
    --qds-control-border-radius-bottom-left: 0px;
    --qds-control-border-width-inline-end: 0px;
  }

  .input-group:dir(ltr) > :first-child:not(:only-child) {
    --qds-control-border-radius-top-right: 0px;
    --qds-control-border-radius-bottom-right: 0px;
    --qds-control-border-width-inline-end: 0px;
  }

  .input-group:dir(ltr) > :last-child:not(:only-child) {
    --qds-control-border-radius-top-left: 0px;
    --qds-control-border-radius-bottom-left: 0px;
  }

  .input-group:dir(rtl) > :first-child:not(:only-child) {
    --qds-control-border-radius-top-left: 0px;
    --qds-control-border-radius-bottom-left: 0px;
    --qds-control-border-width-inline-start: 0px;
  }

  .input-group:dir(rtl) > :last-child:not(:only-child) {
    --qds-control-border-radius-top-right: 0px;
    --qds-control-border-radius-bottom-right: 0px;
  }

  .control-group {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: var(--qds-control-standard-gap-siblings-related);
    width: 100%;
  }

  .control {
    width: 100%;
  }
}

@media (width > 1024px) {
  .qds-footer-subscription {
    max-width: 684px;
  }
}
